import { render, staticRenderFns } from "./NominatedBeneficiaryView.vue?vue&type=template&id=ec9066ee&scoped=true"
import script from "./NominatedBeneficiaryView.vue?vue&type=script&lang=ts"
export * from "./NominatedBeneficiaryView.vue?vue&type=script&lang=ts"
import style0 from "./NominatedBeneficiaryView.vue?vue&type=style&index=0&id=ec9066ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9066ee",
  null
  
)

export default component.exports